import { Component, OnInit, AfterViewInit } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
declare var $: any;

@Component({
    templateUrl:"./pumplocator.component.html"
})
export class PumpLocatorComponent implements OnInit, AfterViewInit{
    public pageTitle: string = 'Pump Locator';
    constructor(private authService: AuthService, private appCommonService: AppCommonService) {
        this.appCommonService.pageContentAdditionalClass = ""; 
        this.appCommonService.pageName = this.pageTitle;
    }
        
    ngOnInit(): void {
               
    }

    ngAfterViewInit(): void {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/pumplocator/pumplocator.component.ts